import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('Window');

export const windowFactory = () => window;
